// Generated by CoffeeScript 2.7.0
var Base;

export default Base = class Base {
  static delegatesToClass(methods, {to}) {
    var i, len, method;
    for (i = 0, len = methods.length; i < len; i++) {
      method = methods[i];
      this[method] = (function(method) {
        return function(...args) {
          return this[to][method].apply(this[to], args);
        };
      })(method);
    }
    return true;
  }

  static delegates(methods, {to, suffix}) {
    var delegator_chain, i, len, method, method_name;
    delegator_chain = to.split('.');
    for (i = 0, len = methods.length; i < len; i++) {
      method = methods[i];
      method_name = `${method}${suffix || ''}`;
      this.prototype[method_name] = (function(method) {
        return function(...args) {
          var delegator;
          delegator = _.reduce(delegator_chain, function(memo, delegator) {
            return memo[delegator];
          }, this);
          return delegator[method].apply(delegator, args);
        };
      })(method);
    }
    return true;
  }

};
